module.exports = __webpack_public_path__ + "img/carAggregation.476a0aa5.svg";